module.exports = __webpack_public_path__ + "img/es.d0a7948c.svg";